// Dependencies imports
import React, { useState, useEffect } from "react";
import { API } from "aws-amplify";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";

// Local imports
import { ReactComponent as Close } from "../../assets/svg/close_black_24dp.svg";
import { authData } from "../../redux/auth/authSlice";
import config from "../../config/aws-exports";
import { Constants } from "../../config/constants";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
} from "@material-ui/data-grid";
// Styles imports
import Acc from "./AccordionPopup.module.scss";

const useStyles = makeStyles(() => ({
  root: {
    display: "inline-block",
    width: "100%",
    paddingTop: "20px",
    "& .super-app-theme--header": {
      backgroundColor: Constants.main_color_1,
      fontSize: "16px",
      color: "rgb(255,255,255)",
      fontFamily: "nunito",
    },
  },
  root1: {
    width: "100%",
  },
  heading: {
    fontSize: "16px",
    fontWeight: 400,
    color: Constants.main_color_1,
  },
  subheading: {
    color: "black",
    fontFamily: "nunito",
    fontSize: "14px",
    fontWeight: "600px",
  },
  "MuiAccordionDetails-root": {
    display: "inline-block",
    width: "100%",
    padding: "10px 20px",
  },
  ".MuiDataGrid-root": {
    fontSize: "14px",
    fontFamily: "nunito",
    fontWeight: 400,
    color: "black",
  },
}));

// Start of main accordion component
const AccordionPopup = (props) => {
  const [loading, setLoading] = useState(true);
  const [courseName, setcourseName] = useState(props.courseData.ttitle);
  const [rows, setRows] = useState([]);
  const classes = useStyles();
  let { handleClose, pgmIaMarks, bscMarks } = props;

  let userDetails = useSelector(authData);

  const iaMarksHeader = bscMarks
    ? "Updated IA marks (30)"
    : `Updated IA marks (${pgmIaMarks})`;

  let columns = [
    {
      field: "col1",
      headerName: "Student Name",
      width: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "col2",
      headerName: "Email id",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "col3",
      headerName: "Enrolment Number",
      width: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "col4",
      headerName: "Phone number",
      width: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "col5",
      headerName: "Country of Residence",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "col6",
      headerName: "Total No. of Modules (active) ",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "col7",
      headerName: "Total Nos. of Modules Completed ",
      width: 400,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "col8",
      headerName: "Percentage of completion",
      width: 400,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "col9",
      headerName: "Total marks for 5",
      width: 400,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "col10",
      headerName: "No. of assignments (active)",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "col11",
      headerName: "Nos. of assignment submitted ",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "col12",
      headerName: "Total Assignment Marks",
      width: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "col13",
      headerName: "Average Assignment marks (for 10)",
      width: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "col14",
      headerName: "Assignment marks for 5",
      width: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "col15",
      headerName: "Round up for 5",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "col16",
      headerName: "1st Test Marks",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "col17",
      headerName: "2nd Test Marks",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "col18",
      headerName: "Repeat Test Marks",
      width: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "col19",
      headerName: "First Large",
      width: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "col20",
      headerName: "Second Large",
      width: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "col21",
      headerName: "Average for 25",
      width: 300,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "col22",
      headerName: "Marks (15)",
      width: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "col23",
      headerName: "Round up(15)",
      width: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "col24",
      headerName: `IA marks (25)`,
      width: 400,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "col25",
      headerName: iaMarksHeader,
      width: 400,
      headerClassName: "super-app-theme--header",
    },
  ];

  if (pgmIaMarks != undefined) {
    let obj = {};

    obj.field = "col26";
    obj.headerName = `IA marks for ${pgmIaMarks}`;
    obj.width = 400;
    obj.headerClassName = "super-app-theme--header";

    if (bscMarks) {
      obj.headerName = `IA marks for 30`;
    }
    columns.push(obj);
  }

  useEffect(() => {
    getuserprogress();
    return () => {};
  }, []);

  async function getuserprogress() {
    setLoading(true);
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        bpid: userDetails.curprgcou.bpid,
        topicids: [props.courseData.btid],
        telective: props.courseData.telective,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      let response = await API.post(
        config.aws_cloud_logic_custom_name,
        "/getmyCoursereports",
        bodyParam,
      );
      if (response === null || response === undefined) {
        setLoading(false);
      }
      let trows = [];
      for (let i = 0; i < response.length; i++) {
        let obj = {};
        obj.id = i;
        obj.col1 = response[i].UNAME;
        obj.col2 = response[i].EMAILID;
        if (
          response[i].USN !== undefined &&
          response[i].USN[userDetails.curprgcou.bpid] !== undefined
        ) {
          obj.col3 = response[i].USN[userDetails.curprgcou.bpid].usn;
        }

        obj.col4 = response[i]?.CNO;
        obj.col5 = response[i].country;
        obj.col6 = response[i].totalActiveModule;
        obj.col7 = response[i].totalCompletedModule;
        obj.col8 = parseFloat(response[i].totalCompletedModulePercent).toFixed(
          2,
        );
        obj.col9 = response[i]?.totalCompletedModulePercentmarks;

        obj.col10 = response[i].totalMiniassignments;

        obj.col11 =
          response[i].totalCompletedMiniassignment == undefined
            ? 0
            : response[i].totalCompletedMiniassignment;

        obj.col12 = response[i]?.totalminiscore;

        obj.col13 =
          response[i].miniAverageScore != null
            ? parseFloat(response[i].miniAverageScore).toFixed(2)
            : 0;

        obj.col14 = response[i]?.miniAverageScorefor5;
        obj.col15 = response[i]?.miniAverageScorefor5roundoff;

        if (Object.keys(response[i]?.Assesment).length > 0) {
          obj.col16 =
            response[i].Assesment[1] != undefined &&
            response[i].Assesment[1] != "NA"
              ? response[i].Assesment[1]
              : "Not Attendeded";
          obj.col17 =
            response[i].Assesment[2] != undefined &&
            response[i].Assesment[2] != "NA"
              ? response[i].Assesment[2]
              : "Not Attendeded";
          obj.col18 =
            response[i].Assesment[3] != undefined &&
            response[i].Assesment[3] != "NA"
              ? response[i].Assesment[3]
              : "Not Attendeded";
        } else {
          obj.col16 = "Not Attendeded";
          obj.col17 = "Not Attendeded";
          obj.col18 = "Not Attendeded";
        }
        let average = [];
        if (Object.keys(response[i].Assesment).length > 0) {
          for (let a = 1; a <= Object.keys(response[i].Assesment).length; a++) {
            if (
              response[i].Assesment[a] != undefined &&
              response[i].Assesment[a] != "NA"
            ) {
              average.push(response[i].Assesment[a]);
            }
          }
          average.sort((a, b) => b - a);

          obj.col19 = average[0];
          obj.col20 = average[1];

          if (average[0] != undefined && average[1] != undefined) {
            obj.col21 = parseFloat(
              ((average[0] + average[1]) / 2 / pgmIaMarks) * 25,
            ).toFixed(2);

            obj.col22 = parseFloat(
              ((average[0] + average[1]) / 2 / pgmIaMarks) * 15,
            ).toFixed(2);

            obj.col23 = Math.ceil(
              parseFloat(
                ((average[0] + average[1]) / 2 / pgmIaMarks) * 15,
              ).toFixed(2),
            );
          } else if (average[0] != undefined && average[1] == undefined) {
            obj.col21 = parseFloat((average[0] / 2 / pgmIaMarks) * 25).toFixed(
              2,
            );

            obj.col22 = parseFloat((average[0] / 2 / pgmIaMarks) * 15).toFixed(
              2,
            );

            obj.col23 = Math.ceil(
              parseFloat((average[0] / 2 / pgmIaMarks) * 15).toFixed(2),
            );
          } else {
            obj.col21 = "Not Attendeded";
            obj.col22 = 0;

            obj.col23 = 0;
          }
        } else {
          obj.col21 = "Not Attendeded";
          obj.col22 = 0;

          obj.col23 = 0;
        }
        obj.col24 =
          (Number(obj?.col23) || 0) +
          (Number(obj?.col15) || 0) +
          (Number(obj?.col9) || 0);

        if (pgmIaMarks) {
          obj.col26 = (obj.col24 * pgmIaMarks) / 25;
        }

        if (pgmIaMarks) {
          obj.col26 = (obj.col24 * pgmIaMarks) / 25;
        }

        if (bscMarks) {
          obj.col26 = Math.ceil((obj.col24 / 25) * 30);
        }

        console.log("response[i]?.UpdatedMarks", response[i]?.UpdatedMarks);

        if (response[i]?.UpdatedMarks) {
          let columnsObj = {};
          obj.field = "col25";
          obj.headerName = `Updated IA marks(${pgmIaMarks})`;
          obj.width = 400;
          obj.headerClassName = "super-app-theme--header";

          columns.push(columnsObj);

          obj.col25 = response[i]?.UpdatedMarks;
        }

        trows.push(obj);
      }
      setRows(trows);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  }

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
          csvOptions={{
            fileName: `Report-${userDetails.curprgcou.bname}-${
              userDetails.curprgcou.pname
            }-${courseName != undefined ? courseName : "Course"}`,
          }}
        />
      </GridToolbarContainer>
    );
  }

  return (
    <div className={Acc.mainpopup}>
      <div className={Acc.closeholder}>
        <Close onClick={handleClose} className={Acc.closebutton} />
      </div>
      <h3>{courseName}</h3>
      <div className={classes.root}>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Skeleton variant="rect" width={1500} height={600} />{" "}
          </div>
        ) : (
          <div style={{ height: 500, width: "100%" }} className={classes.root}>
            <DataGrid
              rows={rows}
              columns={columns}
              className={classes[".MuiDataGrid-root"]}
              components={{
                Toolbar: CustomToolbar,
              }}
              disableSelectionOnClick
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AccordionPopup;
